'use client';
import styles from './styles.module.scss';
import React, { useEffect } from 'react';
import { DeviceType } from '@mybestbrands/types';

export interface Props {
  aboutText: string | undefined;
  headline: string | undefined;
  deviceType: string;
}

const AboutDetailContent = ({ aboutText, headline, deviceType }: Props) => {
  useEffect(() => {
    if (typeof window.__ucCmp !== 'undefined') {
      const handleClick = () => window.__ucCmp.showSecondLayer();

      const links = document.querySelectorAll('#cmpLink');

      links?.forEach((_) => _.addEventListener('click', handleClick));

      return () => {
        links?.forEach((_) => _.removeEventListener('click', handleClick));
      };
    }
  }, []);

  if (!aboutText) return null;
  return (
    <div className="row justify-content-start pt-1 pb-5">
      <div className={deviceType === DeviceType.MOBILE ? 'col-sm-12 col-md-6' : 'col-sm-8 offset-2'}>
        {deviceType === DeviceType.DESKTOP && <h1 className={`${styles['headline']}`}>{headline}</h1>}
        <div className={styles['aboutContent']} dangerouslySetInnerHTML={{ __html: aboutText }} />
      </div>
    </div>
  );
};

export default AboutDetailContent;
